import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import GeneralApiService from "../../services/generalServices";
import translations from "../../assets/locals/translations";

const generateTypeFromLabel = (label) =>
  label.split(" ")[0].toUpperCase();

const formatType = (type) =>
  type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

const ServiceItlCustomer = () => {
  const navigate = useNavigate();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations["en"];
  const generalServices = new GeneralApiService();

  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        const response = await generalServices.getCategoryList();
        if (response && response.isSuccess && Array.isArray(response.result)) {
          const itlCategory = response.result.find((val) => {
            const labelLower = val.label
              ?.toLowerCase()
              .replace(/\s+/g, "")
              .replace(/-/g, "");
            return labelLower === "itlcustomer";
          });

          if (itlCategory) {
            const stage = {
              label: itlCategory.label,
              value: itlCategory.value,
              type: generateTypeFromLabel(itlCategory.label),
            };

            const formattedType = formatType(stage.type);
            navigate(`/sale/data/${formattedType}`, {
              replace: true,
              state: { stage },
            });
          }
        }
      } catch (error) {
        console.error("Failed to load ITL Customer category:", error);
      }
    };

    fetchAndRedirect();
  }, [generalServices, navigate]);

  return (
    <Box className="bg-white p-2">
      <Box sx={{ mb: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {t.itlcustomer || "ITL Customer"}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t.loadingPleaseWait || "Loading, please wait..."}
        </Typography>
      </Box>
    </Box>
  );
};

export default ServiceItlCustomer;

